import React from 'react';
import { Link } from 'react-router-dom';

const Product = ({country}) => {
    return (
        <div>
            <Link to={`/products/${country.name}`}>{country.name}</Link>
        </div>
    );
};

export default Product;